module.exports = "";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/splash/splash.html
 ** module id = 321
 ** module chunks = 0
 **/